export default __webpack_public_path__ + "static/media/LucidaSansItalic.a8b20939.ttf";